<template>
  <div class="card border-0 m-2" style="width: 18rem;">
    <a v-if="imageLink" :href="imageLink" class="" target="_blank">
      <img class="card-img-top custom-img w-100"
           :src="imageSrc"
           :alt="imageAlt"
           style="max-height: 140px; width: auto; object-fit: contain;">
    </a>
    <img v-else class="card-img-top custom-img"
         :src="imageSrc"
         :alt="imageAlt"
         style="max-height: 140px; width: auto; object-fit: contain;">
  </div>
</template>

<style scoped>
.custom-img {
  border-radius: 16px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.custom-img:hover {
  transform: scale(1.05);
  box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>

<script>
import ActivityManager from "@/activity/ActivityManager";

export default {
  name: "VideoGuideCard",
  props: {
    imageSrc: String,
    imageAlt: String,
    imageLink: String,
  },
  methods: {}
};
</script>
